/*
 * Copyright (C) 2019-2022 Corvalent Corporation - All Rights Reserved
 * This software is licensed program property and is Proprietary and Confidential.
 * Unauthorized copying of this file via any medium is strictly prohibited unless
 * prior written permission has been obtained by Corvalent Corporation.
 * In addition, the look and feel of this software as well as the user interface
 * design is also Copyright ©.
 * Notice: This software is not open source.
 * This software is subject to the Corvalent Software License Agreement.
 * You should have received a copy of this license with the software.
 * If not, please write to: sales@corvalent.com
 * All information contained herein is, and remains, the property of
 * Corvalent Corporation and its suppliers, if any. This software may also
 * be covered by U.S. and Foreign Patents, patents in progress, and are
 * protected by trade secret or copyright law
 */

import { statusColorObj, MapLocationPrimaryColorObj } from '../../themes';

function MapLayers() {
  return {
    layers: [
      {
        id: 'locations_layer',
        source: 'locations',
        type: 'fill',
        paint: {
          'fill-color': MapLocationPrimaryColorObj.default,
          'fill-opacity': 0.4,
        },
      },
      {
        id: 'locations_label',
        type: 'symbol',
        source: 'locations',
        layout: {
          'text-field': ['get', 'name'],
          'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
          'text-size': 20,
          'text-anchor': 'center',
          'text-justify': 'auto',
        },
        paint: {
          'text-color': [
            'case',
            ['==', ['get', 'status'], 'OFF'],
            statusColorObj.off,
            ['==', ['get', 'status'], 'DANGER'],
            statusColorObj.danger,
            ['==', ['get', 'status'], 'WARNING'],
            statusColorObj.warning,
            ['==', ['get', 'status'], 'NORMAL'],
            statusColorObj.normal,
            ['==', ['get', 'status'], 'ON'],
            statusColorObj.primary,
            statusColorObj.off,
          ],
          'text-halo-color': '#ffffff',
          'text-halo-width': 1,
        },
      },
      {
        id: 'locations_outline',
        type: 'line',
        source: 'locations',
        paint: {
          'line-color': [
            'case',
            ['==', ['get', 'status'], 'OFF'],
            'rgba(255, 255, 255, 0.8)',
            ['==', ['get', 'status'], 'DANGER'],
            statusColorObj.danger,
            ['==', ['get', 'status'], 'WARNING'],
            statusColorObj.warning,
            ['==', ['get', 'status'], 'NORMAL'],
            statusColorObj.normal,
            ['==', ['get', 'status'], 'ON'],
            statusColorObj.primary,
            'rgba(255, 255, 255, 0.8)',
          ],
          'line-width': 2,
        },
      },
      {
        id: '3d-buildings',
        source: 'composite',
        'source-layer': 'building',
        filter: ['==', 'extrude', 'true'],
        type: 'fill-extrusion',
        minzoom: 15,
        paint: {
          'fill-extrusion-color': statusColorObj.off,

          // use an 'interpolate' expression to add a smooth transition effect to the
          // buildings as the user zooms in
          'fill-extrusion-height': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            0,
            15.05,
            ['get', 'height'],
          ],
          'fill-extrusion-base': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            0,
            15.05,
            ['get', 'min_height'],
          ],
          'fill-extrusion-opacity': 0.5,
        },
      },
      {
        id: 'unclustered-point',
        type: 'symbol',
        minzoom: 8,
        source: 'facilities',
        filter: ['all', ['!=', 'cluster', true]],
        layout: {
          'text-allow-overlap': true,
          'text-field': [
            'format',
            [
              'case',
              ['==', ['get', 'icon'], 'Building Monitoring'],
              'G',
              ['==', ['get', 'icon'], 'Wind Turbine'],
              'F',
              ['==', ['get', 'icon'], 'Industrial Machine'],
              'H',
              ['==', ['get', 'icon'], 'Industrial Process'],
              'I',
              ['==', ['get', 'icon'], 'Well'],
              'D',
              ['==', ['get', 'icon'], 'Building Computer'],
              'C',
              ['==', ['get', 'icon'], 'Building Temperature'],
              'A',
              ['==', ['get', 'icon'], 'Fracking Truck'],
              'E',
              ['==', ['get', 'icon'], 'MRI Machine'],
              'K',
              ['==', ['get', 'icon'], 'Tank'],
              'J',
              'D',
            ],
            {
              'font-scale': 0.8,
              'text-font': ['literal', ['corvalent_icons Regular']],
            },
            '\n',
            {},
            ['get', 'name'],
            {
              'font-scale': 0.6,
              'text-font': ['literal', ['DIN Offc Pro Bold']],
            },
          ],
          'text-size': 36,
        },
        paint: {
          'text-color': 'transparent',
          'text-halo-width': 2,
          'text-halo-color': 'transparent',
        },
      },
      {
        id: 'unclustered_point_far',
        type: 'circle',
        source: 'facilities',
        maxzoom: 8,
        filter: ['!has', 'point_count'],
        paint: {
          'circle-stroke-color': '#ffffff',
          'circle-stroke-width': 2,
          'circle-opacity': 0.8,
          'circle-color': '#00A0A0',
          'circle-radius': 5,
        },
      },
      {
        id: 'clusters',
        type: 'circle',
        source: 'facilities',
        filter: ['has', 'point_count'],
        paint: {
          'circle-stroke-color': '#ffffff',
          'circle-stroke-width': 2,
          'circle-opacity': 0.8,
          'circle-color': '#00A0A0',
          'circle-radius': ['step', ['get', 'point_count'], 20, 5, 30, 50, 40],
        },
      },
      {
        id: 'cluster-count',
        type: 'symbol',
        source: 'facilities',
        // filter: ['has', 'point_count'],
        layout: {
          'text-field': '{point_count_abbreviated}',
          'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
          'text-size': 12,
        },
        paint: {
          'text-color': '#ffffff',
        },
      },
    ],
  };
}

export default MapLayers;
